// extracted by mini-css-extract-plugin
export default {"d3Legend":"d3Legend-ZHSaG","axis":"axis-BGSux"};